<p *ngIf="value">{{ value }}</p>
<ciao-field-error-list [control]="formControlInput" [forceShow]="true" />
